module.exports = __webpack_public_path__ + "static/media/contact-failure.88c438d1.svg";